export default __webpack_public_path__ + "media/images/playpass_logo-20487abcf09c88e0e7abc4317ec8e53c.png";